module.exports = __webpack_public_path__ + "static/overview-whats-2@2x-355cbca7f17085e35a9993695b90fdc4.png";